module.exports = __webpack_public_path__ + "static/media/IMG_20180526_221153.7b1defab.jpg";